// src/Utils/storageKeys.js

export const getCheckedFoldersKey = (caseId, sessionId) =>
  `checkedFolders_case_${caseId}_session_${sessionId}`;

export const getCheckedDocumentsKey = (folderId, sessionId) =>
  `checkedDocuments_folder_${folderId}_session_${sessionId}`;